import { Component } from 'shimmer'

import { Renderer } from './Renderer'

import {
  Scene,
  Vector3,
  Vector2,
  AxesHelper,
} from 'three'

import { PerspectiveCamera } from '@/webGL/cameras'

export class WebGL extends Component {
  constructor () {
    super()

    this.resize = this.resize.bind(this)

    this.scene = new Scene()
    this.sceneScreen = new Scene()
    this.scenePerso = new Scene()

    this.camera = new PerspectiveCamera(50, 1, 1, 1000)
    this.camera.setFocalLength(80)
    this.camera.far = 20000
    this.camera.near = 10
    this.camera.lookAt( new Vector3(0, 0, 0) )

    this.renderer = new Renderer(this.scene, this.camera, this.sceneScreen, this.scenePerso)
    this.resize()
  }

  onUpdate (time) {
    this.camera.update()
    this.renderer.render(time)
  }

  resize (args = {}) {
    args.width = args.width !== void 0 ? args.width : window.innerWidth
    args.height = args.height !== void 0 ? args.height : window.innerHeight
    this.renderer.resize(args)
  }

  destroy () {
    this.renderer.destroy()
  }

  set el (el) {
    this.container = el
    this.renderer.canvas.classList.add('u-wrapper-panel')
    this.renderer.canvas2.classList.add('u-wrapper-panel')
    this.renderer.canvas3.classList.add('u-wrapper-panel')
    this.renderer.canvas3.classList.add('canvas3')
    this.container.appendChild(this.renderer.canvas)
    this.container.appendChild(this.renderer.canvas2)
    this.container.appendChild(this.renderer.canvas3)
  }
}

export const webGL = new WebGL()